/**
 * GetUrlArgsインターフェース
 * URL生成のための引数を定義するインターフェース
 */
interface GetUrlArgs {
  /** 特集ID */
  featuredId: string;
  /** 現在のページ番号 */
  currentPage: number;
}

/**
 * URLを生成する関数
 *
 * @param {GetUrlArgs} args - 引数オブジェクト
 * @param {string} args.featuredId - 特集ID
 * @param {number} args.currentPage - 現在のページ番号
 * @returns {string} 生成されたURL
 */
export const getUrl = ({ featuredId, currentPage }: GetUrlArgs) => {
  const pageInfo = currentPage >= 2 ? `-page__${currentPage}/` : '';

  return `/DodaFront/View/FeaturedJobList/j_fid__${featuredId}/${pageInfo}`;
};
